import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { AboutPage } from './pages'

const AboutRouter = () => (
  <>
    <Routes>
      <Route index element={<AboutPage />} />
    </Routes>

    <Outlet />
  </>
)

export default AboutRouter
